<script setup lang="ts">
  import { cn } from "@/lib/utils"
  import type { HTMLAttributes } from "vue"
  import { Button } from "@/components/ui/button"
  import Icon from "@/components/ui/icons/Icon.vue"

  const props = defineProps<{
    label: string
    class?: HTMLAttributes["class"]
  }>()
</script>

<template>
  <Button
    type="button"
    variant="text"
    size="md"
    :class="
      cn(
        'text-inherit hover:bg-transparent active:bg-transparent dark:text-inherit dark:hover:bg-transparent dark:active:bg-transparent [&[data-state=open]>svg]:rotate-180',
        props.class,
      )
    "
    data-testid="alert-toggle"
  >
    {{ props.label }}
    <Icon
      name="ChevronDown"
      size="sm"
      class="ml-1 shrink-0 transition-transform duration-200"
    />
  </Button>
</template>
